<template>
    <sa-page-layout :data="gruppo" :pathResource="pathResource" :btnBackVisible="true" :btnSaveVisible="false" :btnSaveNotBackVisible="false" :titolo="gruppo.nome" :linkback="linkback" :linkedit="linkedit" :showModalLoading="showModalLoading" @beforeSave="onBeforeSave" @aftersave="onAfterSave">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar float-sm-right sa-margin-right" @click="onSaveMenu" size="sm">
                <b-icon icon="check2"></b-icon>
                Salva e chiudi
            </b-button>
        </template>
        <template slot="table-filter">
            <b-row>
                <b-col cols="12" sm="4">
                    <label>Nome del Gruppo</label>
                    <b-form-input v-model="gruppo.nome" placeholder="Nome"></b-form-input>
                </b-col>
                <b-col cols="12" sm="4">
                    <label>Descrizione del Gruppo</label>
                    <b-form-input v-model="gruppo.descrizione" placeholder="Descrizione"></b-form-input>
                </b-col>
                <b-col cols="12" sm="4">
                    <label>Codice Profilo Applicativo Esterno</label>
                    <b-form-input v-model="gruppo.codiceProfiloApplicazioneEsterna" placeholder="Codice Profilo Applicazione Esterna"></b-form-input>
                </b-col>
            </b-row>
        </template>
        <template slot="table-body">
            <!--<b-tabs content-class="mt-3" class="sa-tab" style="height: 100%" fill>-->
            <div class="sa-config-menu-tab">
                <ul class="sa-config-menu">
                    <li :class="getClassMainManu(voceMenu)" v-for="voceMenu in gruppoVociMenu" :key="voceMenu.routeId">
                        <span class="sa-config-menu-li-span">
                            <span :class="voceMenu.children.length !== 0 ? 'sa-config-menu-li-icon sa-config-menu-pointer' : 'sa-config-menu-li-icon'" @click="onClickIconOpen"><i :class="'fas fa-' + voceMenu.iconCls"></i></span>
                            <p>
                                <span :class="voceMenu.children.length !== 0 ? 'sa-config-menu-li-label sa-config-menu-pointer' : 'sa-config-menu-li-label'" @click="onClickLabelOpen">{{ voceMenu.text }} ({{ voceMenu.routeId }})</span>
                            </p>
                            <span>
                                <b-form-checkbox v-model="voceMenu.selezionato" name="check-button" switch size="lg" @change="onSelectMenuChange(voceMenu, $event)"> </b-form-checkbox>
                            </span>
                            <span class="sa-config-menu-li-arrow"><i class="bi bi-chevron-left arrow"></i></span>
                        </span>
                        <ul class="sa-config-menu-submenu">
                            <li v-for="subitem in voceMenu.children" :key="subitem.routeId" class="sa-config-menu-submenu-li">
                                <span>
                                    <span class="sa-config-menu-submenu-li-icon"><i :class="'fas fa-' + subitem.iconCls"></i></span>
                                    <p>
                                        <span class="sa-config-menu-submenu-li-label">{{ subitem.text }}</span>
                                    </p>
                                    <span>
                                        <b-form-checkbox v-model="subitem.selezionato" name="check-button" :disabled="!voceMenu.selezionato" switch size="lg" @change="onSelectMenuChange(subitem, $event)"> </b-form-checkbox>
                                    </span>
                                </span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <!--</b-tabs>-->
        </template>
    </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
export default {
    components: { SaPageLayout },
    label: "Dettagllio Gruppo s",
    data() {
        return {
            linkback: "/configurazionepazientimenu",
            pathResource: "/pazientemenu/gruppo",
            linkedit: "",
            showModalLoading: false,
            idGruppo: String,
            gruppo: { nome: "", descrizione: "", menu: [], sezioni: [] },
            gruppoMenu: [],
            menu: [],
            vociMenu: [],
            gruppoVociMenu: [],
            menuDaSalvare: [],
        };
    },
    mounted: function () {
        let me = this;
        me.id = this.$route.params.id;
        if (me.id !== "-1") {
            me.linkback = me.linkback + "/view/" + me.id;
        }
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + "/pazientemenu/all";
            axios
                .get(link)
                .then((response) => {
                    me.menu = response.data.data;
                    me.vociMenu = me.menu.map((obj) => ({ ...obj }));
                    link = process.env.VUE_APP_PATH_API + "/pazientemenu/gruppo";
                    axios
                        .get(link, {
                            params: {
                                gruppoId: me.id,
                            },
                        })
                        .then((response) => {
                            me.gruppoMenu = response.data.data;
                            me.menuDaSalvare = me.gruppoMenu.map((item) => ({
                                gruppiId: item.gruppiId,
                                vociMenurouteId: item.vociMenurouteId,
                            }));
                            let routeIdsGruppo = new Set(me.menuDaSalvare.map((item) => item.vociMenurouteId));
                            me.vociMenu = me.menu.map((voce) => ({
                                ...voce,
                                children: [],
                                selezionato: routeIdsGruppo.has(voce.routeId),
                            }));
                            link = process.env.VUE_APP_PATH_API + "/gruppi/";
                            axios.get(link + me.id).then((response) => {
                                me.gruppo = response.data.data;
                            });
                            me.raggruppaVociMenu(null);
                            me.showModalLoading = false;
                        });
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        raggruppaVociMenu(idPadre) {
            let me = this;
            me.gruppoVociMenu = [];
            me.vociMenu.forEach((element) => {
                if (idPadre === element.idPadre) {
                    element.children = [];
                    me.setMenuChildren(element);
                    me.gruppoVociMenu.push(element);
                }
            });
        },
        setMenuChildren(voceMenu) {
            let me = this;
            me.vociMenu.forEach((element) => {
                if (element.idPadre === voceMenu.routeId) {
                    element.children = [];
                    voceMenu.children.push(element);
                }
            });
        },
        onClickIconOpen(e) {
            let me = this;
            me.setMenuClass(e.target.parentElement.parentElement.parentElement.parentElement);
        },
        onClickLabelOpen(e) {
            let me = this;
            me.setMenuClass(e.target.parentElement.parentElement.parentElement);
        },
        setMenuClass(hrmlelement) {
            let elementNumber = hrmlelement.getElementsByClassName("sa-config-menu-submenu")[0].children.length;

            if (hrmlelement.classList.contains("sa-config-menu-li-open")) {
                hrmlelement.getElementsByClassName("sa-config-menu-submenu")[0].style.height = "0px";
                hrmlelement.classList.remove("sa-config-menu-li-open");
            } else {
                hrmlelement.getElementsByClassName("sa-config-menu-submenu")[0].style.height = elementNumber * 42 + "px";
                hrmlelement.classList.add("sa-config-menu-li-open");
            }
        },
        getClassMainManu(voceMenu) {
            let returnValue = "sa-config-menu-li";
            if (voceMenu.children.length === 0) {
                returnValue = "sa-config-menu-li sa-config-menu-li-no-children";
            } else {
                voceMenu.children.forEach((element) => {
                    if (element.selezionato) {
                        returnValue = "sa-config-menu-li sa-config-menu-li-open";
                    }
                });
            }

            return returnValue;
        },
        onBeforeSave(jsonData) {
            delete jsonData.menu;
        },
        onAfterSave() {
            this.salvaMenuGruppo();
        },
        onSaveMenu() {
            let me = this;
            me.showModalLoading = true;
            me.salvaMenuGruppo()
                .then(() => {
                    me.$router.push(me.linkback);
                })
                .catch(() => {
                    me.$bvToast.toast("Errore salvataggio menu", { variant: "danger", solid: true });
                })
                .finally(() => {
                    me.showModalLoading = false;
                });
        },
        salvaMenuGruppo() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/pazientemenu/gruppo";

            return axios
                .post(link, me.menuDaSalvare, {
                    params: {
                        gruppoId: me.id,
                    },
                })
                .then((response) => {
                    console.log("Menu gruppo salvato", response.data);
                })
                .catch((error) => {
                    console.error("Errore salvataggio menu gruppodd", error);
                });
        },
        creaRecordMenuGruppo(voceMenu) {
            let me = this;

            return {
                gruppiId: me.id,
                vociMenurouteId: voceMenu.routeId,
            };
        },
        aggiungiMenuDaSalvare(voceMenu) {
            let me = this;
            let esisteGia = me.menuDaSalvare.some((item) => {
                return item.gruppiId === me.id && item.vociMenurouteId === voceMenu.routeId;
            });
            if (!esisteGia) {
                me.menuDaSalvare.push(me.creaRecordMenuGruppo(voceMenu));
            }
        },
        rimuoviMenuDaSalvare(voceMenu) {
            let me = this;
            me.menuDaSalvare = me.menuDaSalvare.filter((item) => {
                return !(item.gruppiId === me.id && item.vociMenurouteId === voceMenu.routeId);
            });
        },
        onSelectMenuChange(voceMenu, checked) {
            let me = this;
            voceMenu.selezionato = checked;
            if (checked) {
                me.aggiungiMenuDaSalvare(voceMenu);
            } else {
                me.rimuoviMenuDaSalvare(voceMenu);
                if (voceMenu.children && voceMenu.children.length > 0) {
                    voceMenu.children.forEach((figlio) => {
                        figlio.selezionato = false;
                        me.rimuoviMenuDaSalvare(figlio);
                    });
                }
            }
        },
    },
};
</script>
<style>
.sa-config-menu-tab {
    overflow: auto;
    height: 100%;
    padding: 10px 10px 50px 10px;
}
.sa-config-menu {
    display: block;
    list-style-type: none;
    padding-left: 0px;
}
.sa-config-menu-pointer {
    cursor: pointer;
}
.sa-config-menu-li {
    transition: background-color 0.5s linear;
    color: var(--cl-sidebar-item);
    background-color: var(--bg-menu-item-color);
    margin-bottom: 2px;
    border-radius: 5px;
}
.sa-config-menu-li.sa-config-menu-li-no-children {
    background-color: var(--bg-sidebar);
    border-bottom: 1px solid var(--cl-sidebar-item);
}
.sa-config-menu-li.sa-config-menu-li-no-children:hover {
    background-color: var(--bg-sidebar-item) !important;
    color: var(--bg-sidebar-item-hover-text);
}
.sa-config-menu-li.sa-config-menu-li-no-children:hover .sa-config-menu-li-label {
    color: var(--bg-sidebar-item-hover-text);
}
.sa-config-menu-li-icon {
    position: relative;
    display: block;
    width: 32px;
    font-size: 1.8rem;
    color: var(--cl-sidebar-item);
    text-align: center;
}
.sa-config-menu-li-span {
    display: flex;
    height: 32px;
}

.sa-config-menu-li p {
    display: table;
    width: 100%;
    margin-bottom: 0px;
    padding-left: 5px;
}
.sa-config-menu-li p span {
    display: table-cell;
    vertical-align: middle;
}

.sa-config-menu-li-label {
    flex: 1 auto;
    color: var(--cl-sidebar-item);
}

.sa-config-menu-li-arrow {
    line-height: 32px;
}
.sa-config-menu-li-arrow i.arrow {
    display: block;
    transition: all 0.5s ease;
}
.sa-text-right {
    text-align: right;
}
.sa-config-menu-submenu {
    background-color: var(--bg-menu-item-color);
}
.sa-config-menu-li .sa-config-menu-submenu {
    display: block;
    max-height: 0px;
    height: 0px;
    transition: all 0.5s ease-out;
    overflow: hidden;
    list-style-type: none;
}
.sa-config-menu-li.sa-config-menu-li-open .sa-config-menu-submenu {
    display: block;
    max-height: 1000000px;
    height: auto;
    transition: height 0.5s ease-out;
}

.sa-config-menu-li.sa-config-menu-li-open .sa-config-menu-li-arrow i.arrow {
    transform: rotate(-90deg);
    display: block;
    position: relative;
}

.sa-config-menu-submenu-li {
    background-color: transparent;
    border-bottom: 1px solid var(--cl-sidebar-item);
    height: 40px;
}
.sa-config-menu-submenu-li:hover {
    background-color: var(--bg-sidebar-item) !important;
    color: var(--bg-sidebar-item-hover-text);
}
.sa-config-menu-submenu-li span {
    display: flex;
    height: 40px;
}
.sa-config-menu-submenu-li-icon {
    width: 32px;
    text-align: center;
    font-size: 1.6rem;
    padding: 10px 5px 5px 5px;
}
.sa-config-menu-submenu-li-label {
    background-color: transparent;
    font-weight: bold;
}
@media only screen and (max-width: 767px) {
    .sa-text-right {
        text-align: left;
    }
}
.card {
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.125), 0 1px 3px rgba(0, 0, 0, 0.2);
    margin-bottom: 1rem;
}

.sa-col-icon {
    width: 40px;
}
</style>
